import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';

// 理赔保单分页查询
export const claimPolicyPage = data => {
  return http.Axios.post(rootPath + '/api/claim/policyPage', data);
};

// 生成二维码
export const createQRCode = data => {
  return http.Axios.post(rootPath + '/api/claim/createQRCode', data);
};
// 点击理赔列表的理赔按钮的跳转
export const claimapplyClaim=data=>http.Axios.post(rootPath+'/api/claim/applyClaim',data)
//